import { render, staticRenderFns } from "./selectBatch.vue?vue&type=template&id=1fe3d4c4&scoped=true&"
import script from "./selectBatch.vue?vue&type=script&lang=js&"
export * from "./selectBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3d4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe3d4c4')) {
      api.createRecord('1fe3d4c4', component.options)
    } else {
      api.reload('1fe3d4c4', component.options)
    }
    module.hot.accept("./selectBatch.vue?vue&type=template&id=1fe3d4c4&scoped=true&", function () {
      api.rerender('1fe3d4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/giftUser/selectBatch.vue"
export default component.exports